/* @ngInject */
function formattedDateMedium () {
  return function (date, type = 'EN-US') {
    if (!date) {
      return ''
    }

    const defaultFormat = 'MMM DD'

    const formatTypes = {
      'PT-BR': 'DD MMM',
      'EN-US': defaultFormat,
      'ES-ES': defaultFormat
    }

    const formatType = formatTypes[String(type)] || defaultFormat

    const newDate = moment(date)
    const dayAndMonth = capitalizeAndSanitize(newDate.format(formatType))
    const year = newDate.format('YYYY')

    return dayAndMonth + ', ' + year
  }
}

/**
 * This function capitalizes the first letter of a string and removes the caractere (".") of string
 * @param {String} string - String to be capitalized and sanitized
 * @returns {String} - string.
 */
function capitalizeAndSanitize (string) {
  return (string.charAt(0).toUpperCase() + string.slice(1)).replace('.', '')
}

export { formattedDateMedium }
